import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import CircularProgress from '@mui/material/CircularProgress';
import { LoaderWrapper, ImageWrapper } from './loading-state.styled.js';

const LoadingState = () => {
  return jsx(LoaderWrapper, Object.assign({
    "data-testid": "loading"
  }, {
    children: jsx(ImageWrapper, {
      children: jsx(CircularProgress, {
        style: {
          color: 'white'
        },
        size: 64
      })
    })
  }));
};

export { LoadingState };
